import * as loader from "./utils";
import { triggerEvent } from "../../../services/helpers/trigger-event";
import { getMediaUrl } from "../../../services/helpers/get-media-url";

class Preview {
  constructor(file, tmp) {
    this.element = this._create();
    this.loading = true;

    this.tmp = null;

    if (file) {
      loader.loadFile(file)
        .then(url => this._createTmpView(url));
    }
  }

  _create() {
    let preview = document.createElement('div');
    preview.className = "file-preview";

    let remove = document.createElement('div');
    remove.classList.add('file-preview__close');
    remove.innerHTML = `<svg width="10" height="10">
      <use xlink:href="#close-icon" href="#close-icon" />
    </svg>`;
    remove.onclick = () => this._remove();

    preview.appendChild(remove);

    return preview;
  }

  _remove() {
    triggerEvent(this.element, "change");
    this.element.remove();
    
  }

  set loading(value) {
    if (value) {
      this.element.setAttribute('data-loading', '');
    } else {
      this.element.removeAttribute('data-loading');
    }
  }

  set preview(value) {
    if (value) {
      this.element.setAttribute('data-preview', '');
    } else {
      this.element.removeAttribute('data-preview');
      if (this.tmp) this.tmp.remove();
    }
  }

  set loaded(value) {
    if (value) {
      this.element.setAttribute('data-loaded', '');
    } else {
      this.element.removeAttribute('data-loaded');
    }
  }

  set error(value) {
    if (value) {
      this.element.setAttribute('data-error', '');
    } else {
      this.element.removeAttribute('data-error');
    }
  }

  _createTmpView(url) {
    let tmp = document.createElement('img');
    tmp.src = url;
    tmp.className = "file-preview__tmp-view";
    
    this.tmp = tmp;
    this.element.appendChild(this.tmp);
    this.preview = true;
  }

  _createInput(url, name) {
    let input = document.createElement('input');
    input.type = "hidden";
    input.name = name;
    input.value = url;

    return input;
  }

  _createView(url) {
    let view = document.createElement('img');
    view.src = url;
    view.className = "file-preview__view";

    return view;
  }

  show(url, name) {
    url = getMediaUrl(url);
    let input = this._createInput(url, name);
    let view = this._createView(url);

    this.element.appendChild(input);
    this.element.appendChild(view);

    this.loading = false;
    this.preview = false;
    this.loaded = true;

    triggerEvent(this.element, "change");
  }
}

export default Preview;